<template>
  <div class="modal-img" v-if="opened && url">
    <a href="#" class="btn-close" @click.prevent="$emit('closeModal')"><i class="fa fa-times fa-2x"></i></a>
    <vue-pinch-zoom :max-scale="7" :min-scale="1" class="zoom-container" :key="url">
      <img class="image-modal" :src="url" @click.prevent="$emit('closeModal')">
    </vue-pinch-zoom>
  </div>
</template>

<script>
  import VuePinchZoom from 'vue-pinch-zoom'

  export default {
    name: "ModalImage",
    props: ['opened', 'url'],
    components: { VuePinchZoom },
    data() {
      return {
        modalId: this.$helpers.ID()
      }
    }
  }
</script>

<style scoped>
.modal-img {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 9999;
}

.zoom-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-modal {
  max-width: 90%;
  max-height: 90%;
  user-select: none;
  -webkit-user-drag: none;
}
.btn-close {
  color: #FFFFFF;
  position: fixed;
  z-index: 10000;
  top: 15px;
  right: 22px;
}
</style>
